import { loadScene } from 'components/async/scene';
import { Module } from 'modules/security/types/modules';
import * as React from 'react';
import { Route } from 'react-router-dom';
import ModuleRoutes from '../../../components/routing/ModuleRoutes';
import { SUPER_USERS_BASE_ROUTE, SUPER_USERS_MODULE_KEY } from '../constants';

type Props = {
  allowedModules: Module[];
};

const SuperUsersScene = loadScene('superUsers', 'SuperUsersScene');

const SuperUsersRoutes: React.FC<Props> = ({ allowedModules }: Props) => (
  <ModuleRoutes allowedModules={allowedModules} moduleKey={SUPER_USERS_MODULE_KEY}>
    <Route path={[SUPER_USERS_BASE_ROUTE]} exact>
      <SuperUsersScene />
    </Route>
  </ModuleRoutes>
);

export default SuperUsersRoutes;
